import { formatCampaignName } from '../../../UploadAdCreative/UploadAdCreativeCampaignForm/Steps/CampaignNameStep/CampaignNameFields/helpers'
import { getShowBudgetSection } from './helper'
import { getCampaignBudget } from '../../../UploadAdCreative/ImpressionsBudgetSection/helpers'
import { getObjectStoreUrl } from '../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/helpers'

import { OBJECTIVE } from '../../../CampaignForms/fields'
import { BUDGET_LIFETIME, IOS_14_CAMPAIGN } from './fields'
import { AUTO_OPTIMIZED_CAMPAIGN_BUDGET } from '../../../../reusableFields'
import { OUTCOME_APP_PROMOTION, OUTCOME_AWARENESS, REACH } from '../../../../../constants/campaigns'
import { BIDDING_TYPE } from '../../../../Facebook/CampaignForms/CampaignFacebookCreate/CampaignFacebookCreateForm/fields'
import { APPLICATION_ID } from '../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/reusableFields/AppListField/fields'
import { mobilePlatformsEnums } from '../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/reusableFields/fields'

interface Right {
  allocation_type: string
  bid_cap: number
}

interface SelectedPartnership {
  [key: string]: any
}

interface FacebookClientApp {
  id: string
  name: string
  platform: string
  store_url?: string
  [key: string]: any
}

interface CampaignFormValues {
  [OBJECTIVE]: string
  [AUTO_OPTIMIZED_CAMPAIGN_BUDGET]: boolean
  [BUDGET_LIFETIME]: string | number
  [BIDDING_TYPE]: string
  [APPLICATION_ID]: string
  [IOS_14_CAMPAIGN]: boolean
  [key: string]: any
}

interface CampaignPayload {
  account: string
  name: string
  status: string
  buying_type: string
  [OBJECTIVE]: string
  [BUDGET_LIFETIME]?: number
  [BIDDING_TYPE]?: string
  [IOS_14_CAMPAIGN]?: boolean
  promoted_object?: {
    application_id: string
    object_store_url: string
  }
}

interface CreateCampaignPayloadParams {
  values: CampaignFormValues
  adAccountId: string
  right: Right
  selectedPartnership: SelectedPartnership
  facebookClientApps: FacebookClientApp[]
}

export const createCampaignPayload = ({
  values,
  adAccountId,
  right,
  selectedPartnership,
  facebookClientApps
}: CreateCampaignPayloadParams): CampaignPayload => {
  const { allocation_type: rightAllocationType, bid_cap: rightBidCap } = right

  const campaignName = formatCampaignName(values, selectedPartnership)

  const showBudgetSection = getShowBudgetSection(values[OBJECTIVE])
  const autoOptimizedCampaignBudget = values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET]
  const includeBudgetPayload = showBudgetSection && autoOptimizedCampaignBudget

  return {
    account: adAccountId,
    name: campaignName,
    status: 'active',
    buying_type: 'auction',
    // If user selects Reach or Awareness, then the objective is set to Awareness
    [OBJECTIVE]: values[OBJECTIVE] === REACH ? OUTCOME_AWARENESS : values[OBJECTIVE],
    ...(includeBudgetPayload && {
      [BUDGET_LIFETIME]: getCampaignBudget({ values, rightAllocationType, rightBidCap }),
      [BIDDING_TYPE]: values[BIDDING_TYPE]
    }),
    ...(values[OBJECTIVE] === OUTCOME_APP_PROMOTION &&
      values[IOS_14_CAMPAIGN] && {
        [IOS_14_CAMPAIGN]: true,
        promoted_object: {
          application_id: values[APPLICATION_ID],
          object_store_url: getObjectStoreUrl({
            facebookClientApps,
            applicationId: values[APPLICATION_ID],
            platform: mobilePlatformsEnums.iOS
          })
        }
      })
  }
}
